import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PatientsComponent } from '../patients/patients.component';
import { AppointmentsComponent } from '../appointments/appointments.component';
import { MedicalHistoryComponent } from '../medical-history/medical-history.component';
import {PromotionCodeLogComponent} from '../promotion-code-log/promotion-code-log.component';
import {CorporateQueryComponent} from '../corporate-query/corporate-query.component';
import { MyDatePickerModule  } from 'mydatepicker';
import {CUSTOM_ELEMENTS_SCHEMA} from  '@angular/core';
@NgModule({
  imports: [
    CommonModule,
    MyDatePickerModule,
    FormsModule,
     RouterModule.forChild([
            {path : 'data/:id', component : AppointmentsComponent}, 
            {path : 'data/:id', component : AppointmentsComponent}, 
            {path : 'data/:id', component : AppointmentsComponent}, 
            {path : 'data/:id', component : AppointmentsComponent}, 
            {path : 'promotioncodelog', component : PromotionCodeLogComponent},
            {path : 'corporate', component : CorporateQueryComponent}
          ])
  ],
  declarations: [PatientsComponent, AppointmentsComponent, MedicalHistoryComponent, PromotionCodeLogComponent, CorporateQueryComponent],
  exports: [RouterModule],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReportRouteModule { }



// WEBPACK FOOTER //
// ./src/app/section/report/report-route/report-route.module.ts